var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareMediaLasso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1070,
    height: 1223,
    viewBox: "0 0 1070 1223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1025.91 241.096C969.228 133.822 894.881 73.0412 797.475 56.5239C622.956 26.9301 525.203 96.2127 406.328 104.931C287.452 113.649 222.87 41.5305 116.942 9.26575C34.2614 -15.9183 -131.391 30.4017 -184.932 142.023C-237.263 252.242 -285.926 354.015 -213.703 497.126C-142.882 639.027 -17.6582 681.064 65.3026 827.328C148.263 973.592 162.317 1112.75 264.162 1171.57C370.959 1233.24 616.633 1253.04 746.589 1123.64C851.119 1019.56 828.823 857.615 921.65 744.426C1014.48 631.237 1054.96 578.266 1061.85 504.759C1071.37 403.141 1072.23 328.755 1025.91 241.096Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 4.93431
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMediaLasso);
export default __webpack_public_path__ + "static/media/share-media-lasso.273e3263c71216c0016589a95108eab2.svg";
export { ForwardRef as ReactComponent };